/** @format */

import { selectorIsLoadingSearch } from '@/@ducks/general/selectors';
import { selectorAvailabilityRoom } from '@/@ducks/shared/selectors';
import { apiRoomAvailabilityReduced } from '@/api/apiRoomAvailabilityReduced';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { TLocale } from '@/utils/gatsby/types';
import { usePortalCode } from '@/@ducks/shared/hooks/usePortalCode';

const useCardRoom = (code: string, locale: TLocale) => {
  const dispatch = useAppDispatch();
  const { portalCode } = usePortalCode();
  const [isLoadingAvailability, setIsLoadingAvailability] = useState(true);
  const initialRoomAvailability = useAppSelector(store => selectorAvailabilityRoom(store, code));
  const availableFrom = initialRoomAvailability?.availableFrom ?? undefined;

  const isRoomAvailable = useMemo(() => {
    if (!isLoadingAvailability)
      return !initialRoomAvailability || (availableFrom && !initialRoomAvailability?.negotiating);
    return false;
  }, [initialRoomAvailability, availableFrom, isLoadingAvailability]);

  const loadingListRoom = useAppSelector(selectorIsLoadingSearch);
  const controller = new AbortController();

  useEffect(() => {
    moment.locale(locale);
  }, [locale]);

  useEffect(() => {
    if (!availableFrom && !loadingListRoom && !initialRoomAvailability?.availableFrom) {
      setIsLoadingAvailability(true);
      apiRoomAvailabilityReduced({ code, controller, portalCode: portalCode as string })
        .then(availability => {
          setIsLoadingAvailability(false);
          if (availability) {
            dispatch({ type: 'SHARED_SET_AVAILABILITY_ARRAY', payload: availability });
          }
        })
        .catch(error => {
          console.error(error);
        });
    } else {
      setIsLoadingAvailability(false);
    }
    return () => {
      controller.abort();
    };
  }, [loadingListRoom, initialRoomAvailability]);

  return {
    isLoadingAvailability,
    isRoomAvailable,
    availableFrom,
  };
};

export default useCardRoom;
